import axios from '@/libs/api.request'

export const addBanner = data => {
  return axios.request({
    url: '/print/setting/banner',
    data,
    method: 'post'
  })
}

export const bannerList = data => {
  return axios.request({
    url: '/app/home/banner',
    params: data,
    method: 'get'
  })
}

export const delBanner = data => {
  return axios.request({
    url: '/print/setting/setbanner',
    data,
    method: 'post'
  })
}

export const GetSetting = data => {
  return axios.request({
    url: '/print/setting/get',
    data,
    method: 'get'
  })
}

export const SaveSetting = data => {
  return axios.request({
    url: '/print/setting/save',
    data,
    method: 'post'
  })
}

export const GetDownInformation = data => {
  return axios.request({
    url: '/print/information/list',
    params: data,
    method: 'get'
  })
}

export const SaveDownInformation = data => {
  return axios.request({
    url: '/print/information/save',
    data,
    method: 'post'
  })
}

export const DeleteDownInformation = data => {
  return axios.request({
    url: '/print/information/del',
    data,
    method: 'post'
  })
}
export const ResetServer = data => {
  return axios.request({
    url: '/print/setting/server/reset',
    data,
    method: 'post'
  })
}

export const SaveBanner = data => {
  console.log('data', data)
  return axios.request({
    url: '/print/banner',
    data,
    method: 'post'
  })
}

export const GetBanner = params => {
  return axios.request({
    url: '/print/banner',
    params,
    method: 'get'
  })
}
